module.exports = __webpack_public_path__ + "img/error.533ae440.svg";